module.exports = __webpack_public_path__ + "static/img/share_img2.706c5310.png";